import { Share2 } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { SocialNetworksEditorRenderer } from "./editor";
import { SocialNetworksEmailRenderer } from "./email";
import type { SocialNetworksBlockProps } from "./types";
import { SocialNetworksEmailPanelRenderer } from "./email-panel";
import { SocialNetworksWeb } from "./web";
import { SocialNetworksWebEditor } from "./web-editor";


export default registerBlock<SocialNetworksBlockProps>({
  type: "social-networks",
  name: "editorBlocksLibrary.blocks.social-networks.title",
  description: "editorBlocksLibrary.blocks.social-networks.description",
  Icon: Share2,
  category: BlockCategory.ESSENTIALS,
  components: {
    email: {
      component: SocialNetworksEmailRenderer,
      editor: {
        component: SocialNetworksEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: SocialNetworksEmailPanelRenderer,
      },
    },
    web: {
      component: SocialNetworksWeb,
      editor: {
        component: SocialNetworksWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: SocialNetworksEmailPanelRenderer,
      },
    },
  },
});

export type { SocialNetworksBlockProps as SocialNetworksEditorRendererProps } from "./types";
